
import { Shield, Lock } from 'lucide-react';
import { motion } from 'framer-motion';

export const SecurityCompliance = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">Your Data Security is Our Priority</h2>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            {/* HIPAA Compliance */}
            <motion.div 
              className="flex flex-col items-center text-center flex-1 w-full"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-xl shadow-elevation-1 mb-4 border border-gray-100 flex items-center justify-center h-48 w-full">
                <img 
                  src="/lovable-uploads/f42fbb46-419c-448b-894f-f17826befc07.png" 
                  alt="HIPAA Compliant Database" 
                  className="h-32 w-auto object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2 flex items-center">
                <Shield className="w-5 h-5 text-primary mr-2" />
                HIPAA Compliant Database
              </h3>
            </motion.div>
            
            {/* SOC II Compliance */}
            <motion.div 
              className="flex flex-col items-center text-center flex-1 w-full"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-xl shadow-elevation-1 mb-4 border border-gray-100 flex items-center justify-center h-48 w-full">
                <img 
                  src="/lovable-uploads/7ccd4655-c56f-44d3-af4c-32e7edcb59df.png" 
                  alt="SOC II Compliant Database" 
                  className="h-32 w-auto object-contain"
                />
              </div>
              <h3 className="text-xl font-semibold mb-2 flex items-center">
                <Lock className="w-5 h-5 text-primary mr-2" />
                SOC II Compliant Database
              </h3>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

